import axios from 'axios'

import { registerCancelToken, removeCancelToken, responseSuccessInterceptor } from '@/bundles/Http/interceptors/requestInterceptor';

import versionSetup from '../helpers/interceptors'
import { resetTokenAndReattempRequest } from './refresh'

const instance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.VUE_APP_V1_API_URL,
})

instance.interceptors.response.use(
  responseSuccessInterceptor,
  (error) => {
    removeCancelToken(error?.config);
    return resetTokenAndReattempRequest(error)
  }
)

instance.interceptors.response.use(versionSetup, (error) => {
  return Promise.reject(error)
})

instance.interceptors.request.use((config) => {
  registerCancelToken(config);

  return config;
});

export default instance;
